import React, { useEffect, useState, useCallback, useRef } from 'react'
import { GlobalWebSocketManager } from '@/lib/GlobalWebSocketManager'
import { WebSocketContext, type WebSocketContextType } from './WebSocketContextTypes'

export function WebSocketProvider({ children }: { children: React.ReactNode }) {
  const [isConnected, setIsConnected] = useState(false)
  const [connectionState, setConnectionState] = useState<'connecting' | 'connected' | 'disconnected' | 'error'>('disconnected')
  
  const manager = useRef(GlobalWebSocketManager.getInstance())

  // Solo suscribirse a cambios de estado, no manejar conexión
  useEffect(() => {
    // Suscribirse a cambios de estado
    const unsubscribeState = manager.current.subscribeToState((state) => {
      // Solo actualizar si el estado realmente cambió
      setConnectionState(prevState => {
        if (prevState !== state) {
          return state
        }
        return prevState
      })
      setIsConnected(prevConnected => {
        const newConnected = state === 'connected'
        if (prevConnected !== newConnected) {
          return newConnected
        }
        return prevConnected
      })
    })

    // Cleanup al desmontar
    return () => {
      unsubscribeState()
    }
  }, [])

  const subscribe = useCallback((callback: (conversationId?: string, message?: unknown, eventType?: string) => void) => {
    return manager.current.subscribe(callback)
  }, [])

  const connect = useCallback(() => {
    manager.current.connect()
  }, [])

  const disconnect = useCallback(() => {
    manager.current.disconnect()
  }, [])

  const value: WebSocketContextType = {
    isConnected,
    connectionState,
    subscribe,
    connect,
    disconnect
  }

  return (
    <WebSocketContext.Provider value={value}>
      {children}
    </WebSocketContext.Provider>
  )
}

// Hook moved to separate file to fix fast refresh issue
